import { I18n } from "aws-amplify/utils"
import { useContext } from "react"
import { Navigate } from "react-router-dom"
import { UserDataContext, UserDataContextHelper } from "../contexts"
import { useActiveOrgId } from "../hooks"
import { getLinkToOrgById, getLinkToOrgs } from "../LinkUtils"

export default function HomepageRedirect() {
  const { userData } = useContext(UserDataContext)
  const activeOrgId = useActiveOrgId()
  if (!activeOrgId) {
    const numOrgs = userData
      ? UserDataContextHelper.findOrgs(userData).length
      : 0

    return numOrgs > 0 ? (
      <Navigate to={getLinkToOrgs()} />
    ) : (
      <main className="p-8">
        {I18n.get("Ihr Benutzeraccount ist noch keinem Betrieb zugewiesen.")}
      </main>
    )
  }
  return <Navigate to={getLinkToOrgById(activeOrgId, false)} />
}
